import React, { Component } from "react"

class DateTimeSelector extends Component {
  static defaultProps = {
    dateFieldId: "",
    dateValue: undefined,
    dateChangeHandler: null,
    timeFieldId: "",
    timeValue: undefined,
    timeChangeHandler: null,
    timeValueSet: [
      "00:30",
      "01:00",
      "01:30",
      "02:00",
      "02:30",
      "03:00",
      "03:30",
      "04:00",
      "04:30",
      "05:00",
      "05:30",
      "06:00",
      "06:30",
      "07:00",
      "07:30",
      "08:00",
      "08:30",
      "09:00",
      "09:30",
      "10:00",
      "10:30",
      "11:00",
      "11:30",
      "12:00",
      "12:30",
      "13:00",
      "13:30",
      "14:00",
      "14:30",
      "15:00",
      "15:30",
      "16:00",
      "16:30",
      "17:00",
      "17:30",
      "18:00",
      "18:30",
      "19:00",
      "19:30",
      "20:00",
      "20:30",
      "21:00",
      "21:30",
      "22:00",
      "22:30",
      "23:00",
      "23:30",
    ],
    mainLabel: "",
    timeLabel: "",
    formModifiers: "",
    searchOnBlur: false,
  }

  render() {
    const {
      dateFieldId,
      dateValue,
      dateChangeHandler,
      timeFieldId,
      timeValue,
      timeChangeHandler,
      timeValueSet,
      mainLabel,
      timeLabel,
      formModifiers,
      searchOnBlur,
      viewable,
    } = this.props
    return (
      <div className={`form__section form__section--light ${formModifiers} form__section--date-time js--date-time-pair ${viewable ? "d-none" : ""}`}>
        <div className="form__section__inner">
          <div
            className={`form__field form__field--date form__field--date--pikaday is-custom ${
              dateValue ? "is-filled" : ""
            } js--date-form-field rm-this-class-hide-default`}
          >
            <input
              className="form__item js--date"
              readOnly={true}
              name={dateFieldId}
              type="text"
              value={dateValue}
              onBlur={(event) => dateChangeHandler(event, searchOnBlur)}
            />
            <label htmlFor={dateFieldId} className="form__label">
              <span className="form__label__text">
                {mainLabel || "Fra"}&nbsp;&nbsp;<strong>&nbsp;</strong>
              </span>
            </label>
          </div>
        </div>
        <div className="form__section__inner">
          <div
            className={`form__field form__field--select custom-select js--custom-select ${
              timeValue ? "is-filled" : ""
            } js--time-form-field is-custom form-select-time`}
          >
            <button className="custom-select__trigger form__container js--custom-select-trigger">
              <span className="form__valid" />
              <div className="form__item js--custom-select-label" data-selected>
                {timeValue}
              </div>
              <label htmlFor={timeFieldId} className="form__label">
                <span className="form__label__text">
                  {timeLabel || "Tid"}&nbsp;&nbsp;<strong>&nbsp;</strong>
                </span>
              </label>
            </button>
            <div
              id={timeFieldId}
              className="custom-select__list js--custom-select-list js--iosscrollfix"
              role="listbox"
              onClick={(event) => timeChangeHandler(event, searchOnBlur)}
              data-value={timeValue}
            >
              {timeValueSet.map((time, index) => {
                if (timeValue && timeValue === time) {
                  return (
                    <button
                      key={index}
                      className="custom-select__list__item like-anchor"
                      role="option"
                      data-value={time}
                      aria-selected="true"
                      tabIndex="0"
                    >
                      <svg className="svg-icon svg-icon--checkmark">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-checkmark">
                          &nbsp;
                        </use>
                      </svg>
                      {time}
                    </button>
                  )
                } else {
                  return (
                    <button key={index} className="custom-select__list__item " role="option" data-value={time} aria-selected="false">
                      <svg className="svg-icon svg-icon--checkmark">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-checkmark">
                          &nbsp;
                        </use>
                      </svg>
                      {time}
                    </button>
                  )
                }
              })}
            </div>
            <input className="js--custom-select-input js--time-select" type="hidden" />
          </div>
        </div>
      </div>
    )
  }
}

export default DateTimeSelector
